/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPlayerParticipationEvent
 */
export interface AdminPlayerParticipationEvent {
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerParticipationEvent
     */
    entryId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerParticipationEvent
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerParticipationEvent
     */
    teamName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerParticipationEvent
     */
    eventName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerParticipationEvent
     */
    eventDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerParticipationEvent
     */
    matchesPlayed: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminPlayerParticipationEvent
     */
    roster: Array<string>;
}

/**
 * Check if a given object implements the AdminPlayerParticipationEvent interface.
 */
export function instanceOfAdminPlayerParticipationEvent(value: object): value is AdminPlayerParticipationEvent {
    if (!('entryId' in value) || value['entryId'] === undefined) return false;
    if (!('teamId' in value) || value['teamId'] === undefined) return false;
    if (!('matchesPlayed' in value) || value['matchesPlayed'] === undefined) return false;
    if (!('roster' in value) || value['roster'] === undefined) return false;
    return true;
}

export function AdminPlayerParticipationEventFromJSON(json: any): AdminPlayerParticipationEvent {
    return AdminPlayerParticipationEventFromJSONTyped(json, false);
}

export function AdminPlayerParticipationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPlayerParticipationEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': json['entryId'],
        'teamId': json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'eventName': json['eventName'] == null ? undefined : json['eventName'],
        'eventDate': json['eventDate'] == null ? undefined : (new Date(json['eventDate'])),
        'matchesPlayed': json['matchesPlayed'],
        'roster': json['roster'],
    };
}

export function AdminPlayerParticipationEventToJSON(json: any): AdminPlayerParticipationEvent {
    return AdminPlayerParticipationEventToJSONTyped(json, false);
}

export function AdminPlayerParticipationEventToJSONTyped(value?: AdminPlayerParticipationEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': value['entryId'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'eventName': value['eventName'],
        'eventDate': value['eventDate'] == null ? value['eventDate'] : value['eventDate'].toISOString().substring(0,10),
        'matchesPlayed': value['matchesPlayed'],
        'roster': value['roster'],
    };
}

